import { 
  format, 
  formatDistanceToNow, 
  isToday, 
  isTomorrow, 
  isThisWeek,
  isThisMonth,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  addDays,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  parseISO
} from 'date-fns';

export const formatDate = (date, formatStr = 'MMM dd, yyyy') => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
  return format(dateObj, formatStr);
};

export const formatRelativeTime = (date) => {
  if (!date) return '';
  const dateObj = typeof date === 'string' ? parseISO(date) : new Date(date);
  
  if (isToday(dateObj)) return 'Today';
  if (isTomorrow(dateObj)) return 'Tomorrow';
  
  return formatDistanceToNow(dateObj, { addSuffix: true });
};

export const getTimeRemaining = (dueDate) => {
  if (!dueDate) return null;
  
  const due = typeof dueDate === 'string' ? parseISO(dueDate) : new Date(dueDate);
  const now = new Date();
  
  const days = differenceInDays(due, now);
  const hours = differenceInHours(due, now) % 24;
  const minutes = differenceInMinutes(due, now) % 60;
  
  return {
    days,
    hours,
    minutes,
    isOverdue: days < 0,
    totalMinutes: differenceInMinutes(due, now)
  };
};

export const getTimeframeRange = (timeframe) => {
  const now = new Date();
  
  switch (timeframe) {
    case 'today':
      return {
        start: new Date(now.setHours(0, 0, 0, 0)),
        end: new Date(now.setHours(23, 59, 59, 999))
      };
    case 'week':
      return {
        start: startOfWeek(now),
        end: endOfWeek(now)
      };
    case 'month':
      return {
        start: startOfMonth(now),
        end: endOfMonth(now)
      };
    case 'quarter':
      const quarter = Math.floor(now.getMonth() / 3);
      return {
        start: new Date(now.getFullYear(), quarter * 3, 1),
        end: new Date(now.getFullYear(), quarter * 3 + 3, 0)
      };
    default:
      return { start: null, end: null };
  }
};

export const formatDuration = (minutes) => {
  if (!minutes) return '8h';
  
  // const hours = Math.floor(minutes / 60);
  // const mins = minutes % 60;
  
  // if (hours === 0) return `${mins}m`;
  // if (mins === 0) return `${hours}h`;
 
  // TODO: Fixed the logic where one can enter the value like 1h and 20m somethings like this and it will work for now 
  // // modifying it to include only the hour 
   // return `${hours}h ${mins}m`;
  return `${minutes}h `;
};

export const calculateAge = (birthDate) => {
  if (!birthDate) return null;
  
  const birth = typeof birthDate === 'string' ? parseISO(birthDate) : new Date(birthDate);
  const now = new Date();
  
  const diffTime = Math.abs(now - birth);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  
  const years = Math.floor(diffDays / 365.25);
  const months = Math.floor((diffDays % 365.25) / 30.44);
  const days = Math.floor((diffDays % 365.25) % 30.44);
  
  return {
    years,
    months,
    days,
    totalDays: diffDays,
    totalHours: Math.floor(diffTime / (1000 * 60 * 60)),
    totalMinutes: Math.floor(diffTime / (1000 * 60))
  };
};

export default {
  formatDate,
  formatRelativeTime,
  getTimeRemaining,
  getTimeframeRange,
  formatDuration,
  calculateAge
};
